var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-inline-block" },
    [
      _c(
        "b-overlay",
        {
          attrs: {
            show: _vm.isDataSending,
            rounded: "",
            opacity: "0.6",
            "spinner-small": "",
            "spinner-variant": "primary",
          },
        },
        [
          _c(
            "b-btn",
            {
              attrs: {
                disabled: !_vm.$store.getters.getCanSign,
                variant: "custom-green",
              },
              on: { click: _vm.showSignForm },
            },
            [
              _vm._v(
                "Подписать дополнительное соглашение и отправить заказчику"
              ),
            ]
          ),
        ],
        1
      ),
      !_vm.$store.getters.getCanSign
        ? [
            _vm.$store.getters.getLoginType === "cert"
              ? _c(
                  "span",
                  { staticClass: "text-danger pl-3 pt-0 fs-14 w-50 my-auto" },
                  [
                    _vm._v(
                      "Для действия требуется загрузить/заменить МЧД на странице: "
                    ),
                    _c(
                      "router-link",
                      {
                        staticClass: "green-link",
                        attrs: { to: { name: "CabinetUserProfile" } },
                      },
                      [_vm._v("Данные учетной записи")]
                    ),
                  ],
                  1
                )
              : _c(
                  "span",
                  { staticClass: "text-danger pl-3 pt-0 fs-14 w-50 my-auto" },
                  [
                    _vm._v(
                      "Подписание возможно только при авторизации при помощи ЭЦП"
                    ),
                  ]
                ),
          ]
        : _vm._e(),
      _c(
        "b-modal",
        {
          ref: "sign-form-modal",
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            scrollable: "",
            size: "lg",
            title: "Подписать дополнительное соглашение и отправить заказчику",
          },
          on: { close: _vm.cancelSignModal },
          scopedSlots: _vm._u([
            {
              key: "modal-header-close",
              fn: function () {
                return [_c("button-close-modal")]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.showSignModal,
            callback: function ($$v) {
              _vm.showSignModal = $$v
            },
            expression: "showSignModal",
          },
        },
        [
          _c(
            "div",
            { staticClass: "d-block text-left" },
            [
              _c(
                "b-tabs",
                { attrs: { "content-class": "mt-3 px-3" } },
                [
                  _c(
                    "b-tab",
                    {
                      attrs: { active: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _c(
                                "span",
                                { staticClass: "system_link-style fs-16" },
                                [_vm._v("Информация о документе")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c("h4", { staticClass: "font-weight-bold" }, [
                        _vm._v("Информация о заказчике"),
                      ]),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "Наименование организации",
                          value: _vm.purchase.contract.customer_info.name,
                        },
                      }),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "ИНН",
                          value: _vm.purchase.contract.customer_info.inn,
                        },
                      }),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "КПП",
                          value: _vm.purchase.contract.customer_info.kpp,
                        },
                      }),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "ОГРН",
                          value: _vm.purchase.contract.customer_info.ogrn,
                        },
                      }),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "Адрес",
                          value:
                            _vm.purchase.contract.customer_info.legal_address,
                        },
                      }),
                      _c("h4", { staticClass: "font-weight-bold" }, [
                        _vm._v("Информация о поставщиике"),
                      ]),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "Наименование организации",
                          value: _vm.purchase.contract.supplier_info.name,
                        },
                      }),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "ИНН",
                          value: _vm.purchase.contract.supplier_info.inn,
                        },
                      }),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "КПП",
                          value: _vm.purchase.contract.supplier_info.kpp,
                        },
                      }),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "ОГРН",
                          value: _vm.purchase.contract.supplier_info.ogrn,
                        },
                      }),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "Адрес",
                          value:
                            _vm.purchase.contract.supplier_info.legal_address,
                        },
                      }),
                      _c("hr"),
                      _c("h4", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          "Дополнительное соглашение № " +
                            _vm._s(_vm.supplementaryAgreement.number)
                        ),
                      ]),
                      _c("text-row-date", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "Дата заключения дополнительного соглашения",
                          value:
                            _vm.supplementaryAgreement
                              .supplementary_agreement_date,
                        },
                      }),
                      _c("text-row-price", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "Общая стоимость, руб.",
                          value: _vm.supplementaryAgreement.price,
                        },
                      }),
                      _c("text-row-single-document", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "Документы",
                          value:
                            _vm.supplementaryAgreement
                              .supplementary_agreement_file
                              .supplementary_agreement_attachment,
                        },
                      }),
                      _c("hr"),
                      _c("h4", { staticClass: "font-weight-bold" }, [
                        _vm._v("Спецификация"),
                      ]),
                      _vm.supplementaryAgreement.deliverables.length > 0
                        ? _c("b-form-group", [
                            _c(
                              "ul",
                              _vm._l(
                                _vm.supplementaryAgreement.deliverables,
                                function (item, index) {
                                  return _c(
                                    "li",
                                    {
                                      key: index,
                                      staticClass:
                                        "fs-14 grey-color my-auto col-form-label",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(index + 1 + ".") +
                                          " " +
                                          _vm._s(item.name) +
                                          " - " +
                                          _vm._s(item.count) +
                                          " " +
                                          _vm._s(item.okei.local_symbol) +
                                          " * " +
                                          _vm._s(_vm.$formatPrice(item.price)) +
                                          " руб. = " +
                                          _vm._s(
                                            _vm.$formatPrice(item.total_cost)
                                          ) +
                                          " руб. "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "b-tab",
                    {
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _c(
                                "span",
                                { staticClass: "system_link-style fs-16" },
                                [_vm._v("XML")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      !_vm.isSignedXml
                        ? _c("b-form-textarea", {
                            staticClass: "text-monospace fs-12",
                            attrs: {
                              disabled: "",
                              rows: "20",
                              "no-resize": "",
                              "no-auto-shrink": "",
                              wrap: "off",
                            },
                            model: {
                              value: _vm.formXml,
                              callback: function ($$v) {
                                _vm.formXml = $$v
                              },
                              expression: "formXml",
                            },
                          })
                        : _c("b-form-textarea", {
                            staticClass: "text-monospace fs-12",
                            attrs: {
                              disabled: "",
                              rows: "20",
                              "no-resize": "",
                              "no-auto-shrink": "",
                              wrap: "off",
                            },
                            model: {
                              value: _vm.signedFormXml,
                              callback: function ($$v) {
                                _vm.signedFormXml = $$v
                              },
                              expression: "signedFormXml",
                            },
                          }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "w-100 px-3",
              attrs: { slot: "modal-footer" },
              slot: "modal-footer",
            },
            [
              _c("text-row", {
                attrs: {
                  compact: "",
                  label: "Сертификат",
                  value: _vm.certificate?.subjectName,
                },
              }),
              _c(
                "b-button",
                {
                  staticClass: "mr-2 text-uppercase",
                  attrs: {
                    disabled: _vm.isDataSending,
                    variant: "custom-outline-secondary",
                  },
                  on: { click: _vm.cancelSignModal },
                },
                [_vm._v("Отмена")]
              ),
              !_vm.isSignedXml
                ? _c(
                    "b-overlay",
                    {
                      staticClass: "d-inline-block",
                      attrs: {
                        show: _vm.isSigningXml,
                        opacity: "0.6",
                        rounded: "",
                        "spinner-small": "",
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "text-uppercase",
                          attrs: {
                            disabled: !_vm.certificate,
                            variant: "custom-green",
                          },
                          on: { click: _vm.signForm },
                        },
                        [_vm._v("Подписать")]
                      ),
                    ],
                    1
                  )
                : _c(
                    "b-overlay",
                    {
                      staticClass: "d-inline-block",
                      attrs: {
                        show: _vm.isDataSending,
                        opacity: "0.6",
                        rounded: "",
                        "spinner-small": "",
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "text-uppercase",
                          attrs: {
                            disabled: !_vm.certificate,
                            variant: "custom-green",
                          },
                          on: { click: _vm.sendData },
                        },
                        [_vm._v("Отправить")]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }